import { render, staticRenderFns } from "./StudentSelection.vue?vue&type=template&id=0a0b38d6&"
import script from "./StudentSelection.vue?vue&type=script&lang=js&"
export * from "./StudentSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports